import { useState } from "react";
import { sharedLib } from "@shared/services/shared.service.ts";
import { DELETE_EXTERNAL_INVITATION_CACHE_KAY } from "features/configuration/InviteExternalUsers/constants.ts";
import {
  copyCodeToClipboard,
  displayResultMessage,
  openMessage,
} from "utils/misc.tsx";
import { getExternalInviteLink } from "features/configuration/common/utils.ts";
import { getCopyMessage } from "@shared/common/CopyToClipboard/utils.ts";
import CopyOutlined from "@ant-design/icons/CopyOutlined";
import DeleteOutlined from "@ant-design/icons/DeleteOutlined";
import { ExternalAccountInvitation } from "@shared/types";

export const useInvitationActions = (invitation: ExternalAccountInvitation) => {
  const [editModalOpen, setEditModalOpen] = useState(false);

  const deleteAccountInvite =
    sharedLib.sharedApi.configuration.useDeleteAccountInviteMutation({
      fixedCacheKey: DELETE_EXTERNAL_INVITATION_CACHE_KAY,
    })[0];

  const onDeleteClick = () => {
    displayResultMessage(
      deleteAccountInvite({ token: invitation.token }).unwrap()
    ).catch(() => {});
  };

  const onCopyLinkClick = () => {
    copyCodeToClipboard(getExternalInviteLink(invitation.token));
    openMessage(getCopyMessage("Invite link"), "info");
  };

  const actionsItems = [
    {
      key: "copy",
      icon: <CopyOutlined />,
      label: "Copy Link",
      onClick: onCopyLinkClick,
    },
    {
      key: "delete",
      icon: <DeleteOutlined />,
      label: "Delete",
      onClick: onDeleteClick,
    },
  ];

  return {
    actionsItems,
    editModalOpen,
    setEditModalOpen,
  };
};
